let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2mxQA")).then(() => parcelRequire('1lRYl'));